import type { App } from "vue";
import * as Sentry from "@sentry/vue";
import axios from "axios";

const ignoreAxiosStatus: number[] = [422, 401];

export function registerSentry(app: App) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    enabled: import.meta.env.PROD,
    environment: import.meta.env.VITE_APP_IDENTIFIER,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    beforeSend(event, hint) {
      const error = hint.originalException;

      if (
        axios.isAxiosError(error) &&
        error.response?.status &&
        ignoreAxiosStatus.includes(error.response.status)
      ) {
        return null;
      }

      return event;
    },
  });
}
